<template>
    <div v-if="message || errors.length" class="rounded w-full p-5" :class="[alertColor ? 'bg-' + alertColor : 'bg-error']">
        <p class="mb-0" v-if="message" v-html="message"></p>
        <ul class="mt-5" v-if="errors.length">
            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
        </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "AlertComponent",
    props:{
        message: { default: "" },
        errors: { type: Array, default: () => [] },
        color: { type: String, default: "error" }
    },
    computed:{
        ...mapGetters(["global"]),
        alertColor(){
            if(global.flashMessage != undefined && global.flashMessage.color){
                return global.flashMessage.color
            }else{
                return this.color
            }
        }
    },
    data: function () {
        return {
        };
    },
    methods: {
    }
};
</script>
